import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '',total:'' }


export const userSurveryAttemptAction = createAsyncThunk(
    'user-lists',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/userSurveyAttempt?userId=${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const userSurveryAttemptSlice = createSlice({
    name: 'user-lists',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userSurveryAttemptAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userSurveryAttemptAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total=action?.payload?.total
            })
            builder.addCase(userSurveryAttemptAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.data = action?.payload?.data
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const userSurveryAttemptReducer = userSurveryAttemptSlice.reducer